import Rails from '@rails/ujs';
import TelesoftSyncManager from './TelesoftSyncManager.js';
import UnitSyncManager from './UnitSyncManager.js';
import UniticketingSyncManager from './UniticketingSyncManager.js';

export default class BackofficeEntitiesIndex {

  constructor() {
    this.telesoftSync = new TelesoftSyncManager();
    this.unitSync = new UnitSyncManager();
    this.uniticketingSync = new UniticketingSyncManager();
    this.bindEvents();
    this.initBulkTelesoftSyncModal();
    this.initBulkUnitSyncModal();
    this.initBulkUniticketingSyncModal();
  }

  bindEvents() {
    $(".custom-control-input").off('change', this.toggleEntityStatus).on('change', this.toggleEntityStatus);

    // Bind bulk sync buttons
    $('#bulk-sync-telesoft-btn').on('click', () => {
      this.openBulkSyncModal();
    });

    $('#bulk-sync-unit-btn').on('click', () => {
      this.openBulkUnitSyncModal();
    });

    $('#bulk-sync-uniticketing-btn').on('click', () => {
      this.openBulkUniticketingSyncModal();
    });
  }

  initBulkTelesoftSyncModal() {
    const $modal = $('#bulkTelesoftSyncModal');
    if (!$modal.length) return;

    // Reset modal state when opened
    $modal.on('show.bs.modal', () => {
      this.resetBulkModalState();
    });

    // Handle confirm button click
    $('#bulk-confirm-sync-btn').on('click', () => {
      this.performBulkSync();
    });

    // Handle select all checkbox
    $('#select-all-entities').on('change', (e) => {
      const checked = e.target.checked;
      $('.entity-checkbox').prop('checked', checked);
    });

    // Handle individual entity checkboxes
    $(document).on('change', '.entity-checkbox', () => {
      this.updateSelectAllState();
    });
  }

  openBulkSyncModal() {
    // Get all entities from the table
    const entities = this.getAllEntitiesFromTable();
    
    if (entities.length === 0) {
      application.errorNotification("Aucune entité éligible pour la synchronisation. Les entités NexSupport et les entités sans commande ne peuvent pas être synchronisées.");
      return;
    }

    // Store entities data in modal
    $('#bulkTelesoftSyncModal').data('entities', entities);
    
    // Show modal and start checking
    $('#bulkTelesoftSyncModal').modal('show');
    this.performBulkCheck(entities);
  }

  getAllEntitiesFromTable() {
    return this.collectEntitiesFromTable('can-sync');
  }

  getAllEntityRows() {
    const selector = '#basic-datatable';
    if ($.fn.DataTable && $.fn.DataTable.isDataTable && $.fn.DataTable.isDataTable(selector)) {
      const dataTable = $(selector).DataTable();
      const nodesApi = dataTable.rows().nodes();
      const $rows = typeof nodesApi.to$ === 'function' ? nodesApi.to$() : $(nodesApi);
      return $rows.filter('[data-entity-id]');
    }

    return $(`${selector} tbody tr[data-entity-id]`);
  }

  collectEntitiesFromTable(eligibilityAttr) {
    const entities = [];
    this.getAllEntityRows().each(function() {
      const $row = $(this);
      const entityId = $row.data('entity-id');
      const entityName = $row.data('entity-name');
      const isEligible = eligibilityAttr ? $row.data(eligibilityAttr) : true;

      if (entityId && entityName && isEligible === true) {
        entities.push({
          id: entityId,
          name: entityName
        });
      }
    });
    return entities;
  }

  performBulkCheck(entities) {
    this.showBulkCheckingState();
    
    const bulkCheckUrl = $('#bulk-sync-telesoft-btn').data('bulk-check-url');
    
    this.telesoftSync.checkMultipleEntities(entities, bulkCheckUrl)
    .done((data) => {
      if (data.success) {
        this.showBulkSelectionState(data.not_found_entities);
      } else {
        this.showBulkResultState('error', data.error || 'Erreur lors de la vérification des entités.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error checking entities:', error);
      this.showBulkResultState('error', 'Erreur lors de la vérification des entités dans Telesoft.');
    });
  }

  performBulkSync() {
    const selectedEntityIds = [];
    $('.entity-checkbox:checked').each(function() {
      selectedEntityIds.push($(this).val());
    });

    if (selectedEntityIds.length === 0) {
      application.errorNotification("Veuillez sélectionner au moins une entité à synchroniser");
      return;
    }

    this.showBulkProcessingState();

    const bulkSyncUrl = $('#bulk-sync-telesoft-btn').data('bulk-sync-url');

    this.telesoftSync.syncMultipleEntities(selectedEntityIds, bulkSyncUrl)
    .done((data) => {
      if (data.success) {
        this.showBulkResultState('success', `${data.synced_count} entité(s) synchronisée(s) avec succès.`);
      } else {
        this.showBulkResultState('error', data.error || 'Erreur lors de la synchronisation.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing entities:', error);
      this.showBulkResultState('error', 'Erreur lors de la synchronisation avec Telesoft.');
    });
  }

  showBulkCheckingState() {
    $('#bulk-sync-initial-content').hide();
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-checking').show();
    $('#bulk-sync-processing').hide();
    $('#bulk-sync-success').hide();
    $('#bulk-sync-error').hide();
    
    $('#bulk-confirm-sync-btn').prop('disabled', true);
  }

  showBulkSelectionState(notFoundEntities) {
    $('#bulk-sync-checking').hide();
    
    if (notFoundEntities.length === 0) {
      this.showBulkResultState('info', 'Toutes les entités existent déjà dans Telesoft.');
      return;
    }

    $('#bulk-sync-selection').show();
    
    // Populate the entity list
    const $entityList = $('#entities-to-sync-list');
    $entityList.empty();
    
    notFoundEntities.forEach(entity => {
      $entityList.append(`
        <div class="form-check mb-2">
          <input class="form-check-input entity-checkbox" type="checkbox" value="${entity.id}" id="entity-${entity.id}" checked>
          <label class="form-check-label" for="entity-${entity.id}">
            <strong>${entity.name}</strong>
          </label>
        </div>
      `);
    });

    $('#bulk-confirm-sync-btn').prop('disabled', false).show();
    $('#bulk-modal-cancel-btn').show();
    $('#bulk-modal-close-btn').hide();
  }

  showBulkProcessingState() {
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-processing').show();
    $('#bulk-confirm-sync-btn').prop('disabled', true);
  }

  showBulkResultState(type, message) {
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-processing').hide();
    $('#bulk-sync-checking').hide();
    
    if (type === 'success') {
      $('#bulk-sync-success').show();
      $('#bulk-sync-success .alert').text(message);
    } else if (type === 'error') {
      $('#bulk-sync-error').show();
      $('#bulk-sync-error-message').text(message);
    } else if (type === 'info') {
      $('#bulk-sync-info').show();
      $('#bulk-sync-info .alert').text(message);
    }
    
    // Hide action buttons, show close button
    $('#bulk-confirm-sync-btn').hide();
    $('#bulk-modal-cancel-btn').hide();
    $('#bulk-modal-close-btn').show();
  }

  resetBulkModalState() {
    $('#bulk-sync-checking').hide();
    $('#bulk-sync-selection').hide();
    $('#bulk-sync-processing').hide();
    $('#bulk-sync-success').hide();
    $('#bulk-sync-error').hide();
    $('#bulk-sync-info').hide();
    
    $('#bulk-confirm-sync-btn').show().prop('disabled', false);
    $('#bulk-modal-cancel-btn').show();
    $('#bulk-modal-close-btn').hide();
  }

  updateSelectAllState() {
    const totalCheckboxes = $('.entity-checkbox').length;
    const checkedCheckboxes = $('.entity-checkbox:checked').length;
    
    $('#select-all-entities').prop('indeterminate', checkedCheckboxes > 0 && checkedCheckboxes < totalCheckboxes);
    $('#select-all-entities').prop('checked', checkedCheckboxes === totalCheckboxes);
  }

  initBulkUnitSyncModal() {
    const $modal = $('#bulkUnitSyncModal');
    if (!$modal.length) return;

    $modal.on('show.bs.modal', () => {
      this.resetUnitBulkModalState();
    });

    $('#unit-bulk-confirm-sync-btn').on('click', () => {
      this.performBulkUnitSync();
    });

    $('#unit-select-all-entities').on('change', (e) => {
      const checked = e.target.checked;
      $('.unit-entity-checkbox').prop('checked', checked);
    });

    $(document).on('change', '.unit-entity-checkbox', () => {
      this.updateUnitSelectAllState();
    });
  }

  openBulkUnitSyncModal() {
    const entities = this.getUnitEntitiesFromTable();

    if (entities.length === 0) {
      application.errorNotification("Aucune entité éligible pour la synchronisation UniT.");
      return;
    }

    $('#bulkUnitSyncModal').data('entities', entities);
    $('#bulkUnitSyncModal').modal('show');
    this.performBulkUnitCheck(entities);
  }

  getUnitEntitiesFromTable() {
    return this.collectEntitiesFromTable('can-unit-sync');
  }

  performBulkUnitCheck(entities) {
    this.showUnitCheckingState();

    const bulkCheckUrl = $('#bulk-sync-unit-btn').data('bulk-check-url');

    this.unitSync.checkMultipleEntities(entities, bulkCheckUrl)
    .done((data) => {
      if (data.success) {
        const readyEntities = data.ready_entities || [];
        const alreadySynced = data.already_synced_entities || [];
        this.showUnitSelectionState(readyEntities, alreadySynced);
      } else {
        this.showUnitResultState('error', data.error || 'Erreur lors de la vérification des entités.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error checking UniT entities:', error);
      this.showUnitResultState('error', 'Erreur lors de la vérification des entités sur UniT.');
    });
  }

  performBulkUnitSync() {
    const selectedEntityIds = [];
    $('.unit-entity-checkbox:checked').each(function() {
      selectedEntityIds.push($(this).val());
    });

    if (selectedEntityIds.length === 0) {
      application.errorNotification('Veuillez sélectionner au moins une entité à synchroniser sur UniT.');
      return;
    }

    this.showUnitProcessingState();

    const bulkSyncUrl = $('#bulk-sync-unit-btn').data('bulk-sync-url');

    this.unitSync.syncMultipleEntities(selectedEntityIds, bulkSyncUrl)
    .done((data) => {
      if (data.success) {
        const syncedCount = data.synced_count || 0;
        const alreadySyncedCount = data.already_synced_count || 0;
        const summaryParts = [];
        summaryParts.push(`${syncedCount} entité(s) synchronisée(s) avec succès.`);
        if (alreadySyncedCount > 0) {
          summaryParts.push(`${alreadySyncedCount} entité(s) étaient déjà synchronisées.`);
        }
        this.showUnitResultState('success', summaryParts.join(' '));
      } else {
        this.showUnitResultState('error', data.error || 'Erreur lors de la synchronisation UniT.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing UniT entities:', error);
      this.showUnitResultState('error', 'Erreur lors de la synchronisation avec UniT.');
    });
  }

  showUnitCheckingState() {
    $('#unit-bulk-sync-selection').hide();
    $('#unit-bulk-sync-processing').hide();
    $('#unit-bulk-sync-success').hide();
    $('#unit-bulk-sync-error').hide();
    $('#unit-bulk-sync-info').hide();
    $('#unit-selection-info').hide();
    this.hideUnitNoEntitiesAlert();

    $('#unit-bulk-sync-checking').show();
    $('#unit-bulk-confirm-sync-btn').prop('disabled', true);
  }

  showUnitSelectionState(readyEntities, alreadySyncedEntities = []) {
    $('#unit-bulk-sync-checking').hide();
    this.hideUnitNoEntitiesAlert();

    if (readyEntities.length === 0) {
      const alreadyCount = alreadySyncedEntities.length;
      const message = alreadyCount > 0
        ? `${alreadyCount} entité(s) sont déjà synchronisées sur UniT.`
        : 'Aucune entité éligible pour la synchronisation UniT.';
      this.showUnitNoEntitiesAlert(message);
      return;
    }

    const $entityList = $('#unit-entities-to-sync-list');
    $entityList.empty();

    readyEntities.forEach((entity) => {
      const unitLabel = entity.unit_universal_id ? `<span class="text-muted ml-1">(${entity.unit_universal_id})</span>` : '';
      $entityList.append(`
        <div class="form-check mb-2">
          <input class="form-check-input unit-entity-checkbox" type="checkbox" value="${entity.id}" id="unit-entity-${entity.id}" checked>
          <label class="form-check-label" for="unit-entity-${entity.id}">
            <strong>${entity.name}</strong> ${unitLabel}
          </label>
        </div>
      `);
    });

    $('#unit-selection-info').hide();

    $('#unit-bulk-sync-selection').show();
    $('#unit-bulk-confirm-sync-btn').prop('disabled', false).show();
    $('#unit-bulk-modal-cancel-btn').show();
    $('#unit-bulk-modal-close-btn').hide();

    this.updateUnitSelectAllState();
  }

  showUnitProcessingState() {
    $('#unit-bulk-sync-selection').hide();
    $('#unit-bulk-sync-processing').show();
    $('#unit-bulk-confirm-sync-btn').prop('disabled', true);
  }

  showUnitResultState(type, message) {
    $('#unit-bulk-sync-selection').hide();
    $('#unit-bulk-sync-processing').hide();
    $('#unit-bulk-sync-checking').hide();
    this.hideUnitNoEntitiesAlert();

    if (type === 'success') {
      $('#unit-bulk-sync-success').show();
      $('#unit-bulk-sync-success .unit-bulk-success-message').text(message);
    } else if (type === 'error') {
      $('#unit-bulk-sync-error').show();
      $('#unit-bulk-sync-error-message').text(message);
    } else {
      this.showUnitNoEntitiesAlert(message);
      return;
    }

    $('#unit-bulk-confirm-sync-btn').hide();
    $('#unit-bulk-modal-cancel-btn').hide();
    $('#unit-bulk-modal-close-btn').show();
  }

  showUnitNoEntitiesAlert(message) {
    $('#unit-bulk-sync-info').hide();
    $('#unit-bulk-sync-success').hide();
    $('#unit-bulk-sync-error').hide();
    $('#unit-bulk-sync-selection').hide();
    $('#unit-bulk-sync-processing').hide();
    $('#unit-bulk-sync-checking').hide();

    $('#unit-bulk-no-entities-alert .unit-bulk-no-entities-message').text(message);
    $('#unit-bulk-no-entities-alert').show();

    $('#unit-bulk-confirm-sync-btn').hide();
    $('#unit-bulk-modal-cancel-btn').hide();
    $('#unit-bulk-modal-close-btn').show();
  }

  hideUnitNoEntitiesAlert() {
    $('#unit-bulk-no-entities-alert').hide();
  }

  resetUnitBulkModalState() {
    $('#unit-bulk-sync-checking').hide();
    $('#unit-bulk-sync-selection').hide();
    $('#unit-bulk-sync-processing').hide();
    $('#unit-bulk-sync-success').hide();
    $('#unit-bulk-sync-error').hide();
    $('#unit-bulk-sync-info').hide();
    $('#unit-selection-info').hide();
    this.hideUnitNoEntitiesAlert();

    $('#unit-bulk-confirm-sync-btn').show().prop('disabled', false);
    $('#unit-bulk-modal-cancel-btn').show();
    $('#unit-bulk-modal-close-btn').hide();
  }

  updateUnitSelectAllState() {
    const totalCheckboxes = $('.unit-entity-checkbox').length;
    const checkedCheckboxes = $('.unit-entity-checkbox:checked').length;

    $('#unit-select-all-entities').prop('indeterminate', checkedCheckboxes > 0 && checkedCheckboxes < totalCheckboxes);
    $('#unit-select-all-entities').prop('checked', checkedCheckboxes === totalCheckboxes);
  }

  initBulkUniticketingSyncModal() {
    const $modal = $('#bulkUniticketingSyncModal');
    if (!$modal.length) return;

    $modal.on('show.bs.modal', () => {
      this.resetUniticketingBulkModalState();
    });

    $('#uniticketing-bulk-confirm-sync-btn').on('click', () => {
      this.performBulkUniticketingSync();
    });

    $('#uniticketing-select-all-entities').on('change', (e) => {
      const checked = e.target.checked;
      $('.uniticketing-entity-checkbox').prop('checked', checked);
    });

    $(document).on('change', '.uniticketing-entity-checkbox', () => {
      this.updateUniticketingSelectAllState();
    });
  }

  openBulkUniticketingSyncModal() {
    const entities = this.getUniticketingEntitiesFromTable();

    if (entities.length === 0) {
      application.errorNotification('Aucune entité éligible pour la synchronisation Uniticketing.');
      return;
    }

    $('#bulkUniticketingSyncModal').data('entities', entities);
    $('#bulkUniticketingSyncModal').modal('show');
    this.performBulkUniticketingCheck(entities);
  }

  getUniticketingEntitiesFromTable() {
    return this.collectEntitiesFromTable('can-uniticketing-sync');
  }

  performBulkUniticketingCheck(entities) {
    this.showUniticketingCheckingState();

    const bulkCheckUrl = $('#bulk-sync-uniticketing-btn').data('bulk-check-url');

    this.uniticketingSync.checkMultipleEntities(entities, bulkCheckUrl)
    .done((data) => {
      if (data.success) {
        const readyEntities = data.ready_entities || [];
        const alreadySynced = data.already_synced_entities || [];
        this.showUniticketingSelectionState(readyEntities, alreadySynced);
      } else {
        this.showUniticketingResultState('error', data.error || 'Erreur lors de la vérification des entités Uniticketing.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error checking Uniticketing entities:', error);
      this.showUniticketingResultState('error', 'Erreur lors de la vérification des entités sur Uniticketing.');
    });
  }

  performBulkUniticketingSync() {
    const selectedEntityIds = [];
    $('.uniticketing-entity-checkbox:checked').each(function() {
      selectedEntityIds.push($(this).val());
    });

    if (selectedEntityIds.length === 0) {
      application.errorNotification('Veuillez sélectionner au moins une entité à synchroniser sur Uniticketing.');
      return;
    }

    this.showUniticketingProcessingState();

    const bulkSyncUrl = $('#bulk-sync-uniticketing-btn').data('bulk-sync-url');

    this.uniticketingSync.syncMultipleEntities(selectedEntityIds, bulkSyncUrl)
    .done((data) => {
      if (data.success) {
        const syncedCount = data.synced_count || 0;
        const alreadySyncedCount = data.already_synced_count || 0;
        const summaryParts = [];
        summaryParts.push(`${syncedCount} entité(s) synchronisée(s) avec succès.`);
        if (alreadySyncedCount > 0) {
          summaryParts.push(`${alreadySyncedCount} entité(s) étaient déjà synchronisées.`);
        }
        this.showUniticketingResultState('success', summaryParts.join(' '));
      } else {
        this.showUniticketingResultState('error', data.error || 'Erreur lors de la synchronisation Uniticketing.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing Uniticketing entities:', error);
      this.showUniticketingResultState('error', 'Erreur lors de la synchronisation avec Uniticketing.');
    });
  }

  showUniticketingCheckingState() {
    $('#uniticketing-bulk-sync-selection').hide();
    $('#uniticketing-bulk-sync-processing').hide();
    $('#uniticketing-bulk-sync-success').hide();
    $('#uniticketing-bulk-sync-error').hide();
    $('#uniticketing-bulk-sync-info').hide();
    $('#uniticketing-selection-info').hide();
    this.hideUniticketingNoEntitiesAlert();

    $('#uniticketing-bulk-sync-checking').show();
    $('#uniticketing-bulk-confirm-sync-btn').prop('disabled', true);
  }

  showUniticketingSelectionState(readyEntities, alreadySyncedEntities = []) {
    $('#uniticketing-bulk-sync-checking').hide();
    this.hideUniticketingNoEntitiesAlert();

    if (readyEntities.length === 0) {
      const alreadyCount = alreadySyncedEntities.length;
      const message = alreadyCount > 0
        ? `${alreadyCount} entité(s) sont déjà synchronisées sur Uniticketing.`
        : 'Aucune entité éligible pour la synchronisation Uniticketing.';
      this.showUniticketingNoEntitiesAlert(message);
      return;
    }

    const $entityList = $('#uniticketing-entities-to-sync-list');
    $entityList.empty();

    readyEntities.forEach((entity) => {
      $entityList.append(`
        <div class="form-check mb-2">
          <input class="form-check-input uniticketing-entity-checkbox" type="checkbox" value="${entity.id}" id="uniticketing-entity-${entity.id}" checked>
          <label class="form-check-label" for="uniticketing-entity-${entity.id}">
            <strong>${entity.name}</strong>
          </label>
        </div>
      `);
    });

    $('#uniticketing-selection-info').hide();

    $('#uniticketing-bulk-sync-selection').show();
    $('#uniticketing-bulk-confirm-sync-btn').prop('disabled', false).show();
    $('#uniticketing-bulk-modal-cancel-btn').show();
    $('#uniticketing-bulk-modal-close-btn').hide();

    this.updateUniticketingSelectAllState();
  }

  showUniticketingProcessingState() {
    $('#uniticketing-bulk-sync-selection').hide();
    $('#uniticketing-bulk-sync-processing').show();
    $('#uniticketing-bulk-confirm-sync-btn').prop('disabled', true);
  }

  showUniticketingResultState(type, message) {
    $('#uniticketing-bulk-sync-selection').hide();
    $('#uniticketing-bulk-sync-processing').hide();
    $('#uniticketing-bulk-sync-checking').hide();
    this.hideUniticketingNoEntitiesAlert();

    if (type === 'success') {
      $('#uniticketing-bulk-sync-success').show();
      $('#uniticketing-bulk-sync-success .uniticketing-bulk-success-message').text(message);
    } else if (type === 'error') {
      $('#uniticketing-bulk-sync-error').show();
      $('#uniticketing-bulk-sync-error-message').text(message);
    } else {
      this.showUniticketingNoEntitiesAlert(message);
      return;
    }

    $('#uniticketing-bulk-confirm-sync-btn').hide();
    $('#uniticketing-bulk-modal-cancel-btn').hide();
    $('#uniticketing-bulk-modal-close-btn').show();
  }

  showUniticketingNoEntitiesAlert(message) {
    $('#uniticketing-bulk-sync-info').hide();
    $('#uniticketing-bulk-sync-success').hide();
    $('#uniticketing-bulk-sync-error').hide();
    $('#uniticketing-bulk-sync-selection').hide();
    $('#uniticketing-bulk-sync-processing').hide();
    $('#uniticketing-bulk-sync-checking').hide();

    $('#uniticketing-bulk-no-entities-alert .uniticketing-bulk-no-entities-message').text(message);
    $('#uniticketing-bulk-no-entities-alert').show();

    $('#uniticketing-bulk-confirm-sync-btn').hide();
    $('#uniticketing-bulk-modal-cancel-btn').hide();
    $('#uniticketing-bulk-modal-close-btn').show();
  }

  hideUniticketingNoEntitiesAlert() {
    $('#uniticketing-bulk-no-entities-alert').hide();
  }

  resetUniticketingBulkModalState() {
    $('#uniticketing-bulk-sync-checking').hide();
    $('#uniticketing-bulk-sync-selection').hide();
    $('#uniticketing-bulk-sync-processing').hide();
    $('#uniticketing-bulk-sync-success').hide();
    $('#uniticketing-bulk-sync-error').hide();
    $('#uniticketing-bulk-sync-info').hide();
    $('#uniticketing-selection-info').hide();
    this.hideUniticketingNoEntitiesAlert();

    $('#uniticketing-bulk-confirm-sync-btn').show().prop('disabled', false);
    $('#uniticketing-bulk-modal-cancel-btn').show();
    $('#uniticketing-bulk-modal-close-btn').hide();
  }

  updateUniticketingSelectAllState() {
    const totalCheckboxes = $('.uniticketing-entity-checkbox').length;
    const checkedCheckboxes = $('.uniticketing-entity-checkbox:checked').length;

    $('#uniticketing-select-all-entities').prop('indeterminate', checkedCheckboxes > 0 && checkedCheckboxes < totalCheckboxes);
    $('#uniticketing-select-all-entities').prop('checked', checkedCheckboxes === totalCheckboxes);
  }

  onDataChanged(data) {
  }

  onDestroy() {
    // Clean up event listeners
    $('#bulk-sync-telesoft-btn').off('click');
    $('#bulkTelesoftSyncModal').off('show.bs.modal');
    $('#bulk-confirm-sync-btn').off('click');
    $('#select-all-entities').off('change');
    $(document).off('change', '.entity-checkbox');
    $('#bulk-sync-unit-btn').off('click');
    $('#bulkUnitSyncModal').off('show.bs.modal');
    $('#unit-bulk-confirm-sync-btn').off('click');
    $('#unit-select-all-entities').off('change');
    $(document).off('change', '.unit-entity-checkbox');
    $('#bulk-sync-uniticketing-btn').off('click');
    $('#bulkUniticketingSyncModal').off('show.bs.modal');
    $('#uniticketing-bulk-confirm-sync-btn').off('click');
    $('#uniticketing-select-all-entities').off('change');
    $(document).off('change', '.uniticketing-entity-checkbox');
  }

  toggleEntityStatus(e) {
    const checkbox = $(e.target);
    const url = checkbox.data('url');
    const isEnabled = checkbox.is(':checked');
    const row = checkbox.closest('tr');

    Rails.ajax({
      url: url,
      type: 'PUT',
      data: `entity[is_enabled]=${isEnabled}`,
      success: () => {
        application.successNotification("Entreprise mise à jour avec succès");
        if (isEnabled) {
          row.removeClass('table-secondary');
          row.find('td:first-child').removeClass('text-muted');
        } else {
          row.addClass('table-secondary');
          row.find('td:first-child').addClass('text-muted');
        }
      },
      error: () => {
        checkbox.prop('checked', !isEnabled);
        application.errorNotification("Erreur lors de la mise à jour de l'entreprise");
      }
    });
  }
}